"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropoutAnalysis = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const IncompleteInterviewsLastAction = ({ data }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const incompleteInterviewsLastEventCounts = data.incompleteInterviewsLastActionCounts || [];
    return (react_1.default.createElement("section", { className: "monitoring-chart-container admin-widget-container" },
        react_1.default.createElement("h3", null, t('admin:monitoring.RespondentBehavior.IncompleteInterviewsLastActions')),
        incompleteInterviewsLastEventCounts.length > 0 ? (react_1.default.createElement("div", { className: "monitoring-table-container" },
            react_1.default.createElement("table", { className: "monitoring-table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, t('admin:monitoring.RespondentBehavior.EventType')),
                        react_1.default.createElement("th", null, t('admin:monitoring.RespondentBehavior.Count')))),
                react_1.default.createElement("tbody", null, incompleteInterviewsLastEventCounts.map((row, idx) => (react_1.default.createElement("tr", { key: idx },
                    react_1.default.createElement("td", null, t(`admin:monitoring.RespondentBehavior.eventTypes.${row.eventType}`)),
                    react_1.default.createElement("td", null, row.count)))))))) : (react_1.default.createElement("div", { className: "monitoring-no-data" }, t('admin:monitoring.RespondentBehavior.NoData')))));
};
const DropoutAnalysis = ({ data }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("details", { className: "monitoring-collapsible", open: true },
        react_1.default.createElement("summary", { className: "monitoring-collapsible__summary" }, t('admin:monitoring.RespondentBehavior.DropoutAnalysis')),
        react_1.default.createElement("div", { className: "monitoring-collapsible__content" },
            react_1.default.createElement(IncompleteInterviewsLastAction, { data: data }))));
};
exports.DropoutAnalysis = DropoutAnalysis;
exports.default = exports.DropoutAnalysis;
//# sourceMappingURL=DropoutAnalysis.js.map